import React from 'react'
import {bubble as Menu} from 'react-burger-menu'
class SlidingMenu extends React.Component{
  constructor(props){
    super(props)
    this.setZIndex = this.setZIndex.bind(this)
  }

  componentDidMount(){
    document.getElementsByClassName('bm-burger-button')[0].style.zIndex='19'
  }

  setZIndex(){
    document.getElementsByClassName('bm-overlay')[0].style.zIndex='15';
    document.getElementsByClassName('bm-menu-wrap')[0].style.zIndex='20';
  }

  render(){
    return (
      <Menu onStateChange={this.setZIndex}>
        <a className="menu-item" href="#welcome">
            <i className="fa fa-user-circle-o"></i>Welcome</a>
        <a className="menu-item" href="#about"><i className="fa fa-id-badge"></i>About</a>
        <a className="menu-item" href="#projects">
          <i className="fa fa-terminal"></i>Projects</a>
        <a className="menu-item" href="#tutorials">
        <i className="fa fa-comments"></i>Blogs & Tutorials</a>

        <a className="menu-item" href="#resume"><i className="fa fa-briefcase"></i>Resume</a>
        <a className="menu-item" href="#technologies"><i className="fa fa-laptop"></i>Technologies</a>
        <a className="menu-item" href="#contact"><i className="fa fa-vcard-o"></i>Contact</a>
        <a className="menu-item" href="./assets/docs/resume.pdf" target="_blank"><i className="fa fa-download"></i>Resume (PDF)</a>

      </Menu>
    )
  }
}

export default SlidingMenu


// WEBPACK FOOTER //
// ./app/components/SlidingMenu.js